import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyWebsiteDesignTool = loadable(() => import(/* webpackChunkName: "content/websitedesigntool" */ '.'));
